import { z } from "zod";
import { type ParserType, parser } from "./parser";
import { Tags } from "./tag";

export type Note = ParserType<typeof Note>;
export const Note = parser(
  z.strictObject({
    id: z.string(),
    title: z.string(),
    // This contains the raw HTML from the note, to be displayed as is.
    contentHtml: z.string(),
    tags: Tags.schema,
  }),
);

export type Notes = ParserType<typeof Notes>;
export const Notes = parser(z.array(Note.schema));
